// ======================================================================
// File Name       : userHistoryContent
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USER_HISTORY_CONTENT_RECEIVE_CONTENT_LIST = 'USER_HISTORY_CONTENT_RECEIVE_CONTENT_LIST';
export const USER_HISTORY_CONTENT_RECEIVE_ITEM_LIST = 'USER_HISTORY_CONTENT_RECEIVE_ITEM_LIST';
export const USER_HISTORY_CONTENT_RECEIVE_EXECUTION_NUMBER = 'USER_HISTORY_CONTENT_RECEIVE_EXECUTION_NUMBER';
export const USER_HISTORY_CONTENT_RECEIVE_USER_LIST = 'USER_HISTORY_CONTENT_RECEIVE_USER_LIST';
export const USER_HISTORY_CONTENT_RECEIVE_GROUP_LIST = 'USER_HISTORY_CONTENT_RECEIVE_GROUP_LIST';
export const USER_HISTORY_CONTENT_RECEIVE_GROUP_RELATION_LIST = 'USER_HISTORY_CONTENT_RECEIVE_GROUP_RELATION_LIST';
export const GET_EACH_ITEM_STATUS_COUNT = 'GET_EACH_ITEM_STATUS_COUNT';
// #7386 START
export const EACH_DRILL_ENFORCE_STATUS_SUMMARY = 'EACH_DRILL_ENFORCE_STATUS_SUMMARY';
export const EACH_QUESTION_ANSWER_CONTENT_SUMMARY = 'EACH_QUESTION_ANSWER_CONTENT_SUMMARY';
// #7386 END
// #7464 START
export const USER_HISTORY_CONTENT_RESET_DATA = 'USER_HISTORY_CONTENT_RESET_DATA';
// #7464 END
